module.exports = __webpack_public_path__ + "assets/images/slope-education/desktop.svg?v=effdb8fa";